const dhhtimages = [
   require('./dhht-0.png'),
   require('./dhht-1.png'),
   require('./dhht-2.png'),
   require('./dhht-3.png'),
   require('./dhht-4.png'),
   require('./dhht-5.png'),
   require('./dhht-6.png'),
   require('./dhht-8.png'),
];

export default dhhtimages;